import { StanUnsplashImageCropSelectorRef, StanUnsplashImageSelector } from '@/components';
import { resizeImage } from '@/components/core-components/StanCrop/StanCrop.logic';

import { useFileUpload } from '@/hooks/useFileUpload';
import { stanNotify } from '@/lib/stanNotify';
import { forwardRef, useImperativeHandle, useState } from 'react';

export interface Props {
    onChange?: (src: string) => void;
    onStartUpload?: () => void;
    onUploadError?: () => void;
    width: number;
}

export const UnsplashImageSelector = forwardRef<StanUnsplashImageCropSelectorRef, Props>(
    ({ onChange, onStartUpload, onUploadError, width }, forwardedRef) => {
        const [selectorOpen, setSelectorOpen] = useState(false);

        const onError = () => {
            stanNotify({ type: 'error', title: 'Uh oh!', text: 'Failed to upload image, please try again.' });
            onUploadError?.();
        };
        const onUploaded = (payload: { name: string; src: string }) => {
            setSelectorOpen(false);
            onChange?.(payload.src);
        };

        useImperativeHandle(forwardedRef, () => ({
            open: () => {
                setSelectorOpen(true);
            },
        }));

        const { uploadSingleFile } = useFileUpload({
            objectType: 'image',
            onUploaded,
            onError,
        });

        return (
            <StanUnsplashImageSelector
                isOpen={selectorOpen}
                onClose={() => {
                    setSelectorOpen(false);
                }}
                onImagePicked={async (file: File) => {
                    onStartUpload?.();
                    const resizedFile = await resizeImage(file, width);
                    setSelectorOpen(false);
                    uploadSingleFile(resizedFile, 0);
                }}
            />
        );
    }
);
